import { render } from "./RiskManagement.vue?vue&type=template&id=16616944&scoped=true"
import script from "./RiskManagement.vue?vue&type=script&lang=js"
export * from "./RiskManagement.vue?vue&type=script&lang=js"

import "./RiskManagement.vue?vue&type=style&index=0&id=16616944&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16616944"]])

export default __exports__